<th class="px-6 py-3 text-sm border-r-1 dark:border-r-2 dark:border-gray-300 dark:bg-gray-700 dark:text-gray-400">
  <ng-content></ng-content>
</th>
